<template>
  <div v-if="isFetching" class="size-32">
    <BaseInnerLoading spinner-class="size-8" />
  </div>
  <template v-else-if="merchantGroup">
    <div class="flex justify-between pt-4">
      <h2
        :class="[
          'line-clamp-1 text-lg font-semibold text-background-fg',
        ]"
      >
        {{ merchantGroup.name }}
      </h2>
    </div>
    <div class="w-[80vw] max-w-3xl py-4">
      <div class="mb-4">
        <div class="border-b border-gray-200">
          <nav
            class="-mb-px flex space-x-8"
            aria-label="Tabs"
          >
            <button
              v-for="tab in tabs"
              :key="tab"
              :class="[
                currentTab === tab
                  ? 'border-primary text-primary'
                  : 'border-transparent text-background-fg/70 hover:border-background-fg/8 hover:text-background-fg/87',
                'whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium',
              ]"
              @click="goToTab(tab)"
              >{{ tab }}</button
            >
          </nav>
        </div>
      </div>
      <MerchantGroupDetailMerchants
        v-if="currentTab === 'Merchants'"
        :merchants="merchantGroup.merchants"
      />
      <MerchantGroupDetailAdmins
        v-else-if="currentTab === 'Admins'"
        :admins="merchantGroup.admins"
      />
    </div>
  </template>
</template>

<script setup lang="ts">
import type { RetrieveMerchantGroupResponse } from "@/services/merchants/retrieveMerchantGroup"

const props = defineProps<{
  merchantGroupId: string
}>()

const router = useRouter()

const merchantGroup = ref<RetrieveMerchantGroupResponse>()
const isFetching = ref(false)

onMounted(async () => {
  try {
    isFetching.value = true
    merchantGroup.value = await retrieveMerchantGroup(
      props.merchantGroupId
    )
  } catch {
    toast.error("Failed to fetch merchant group")
    router.push({ name: "merchantGroupIndex" })
  } finally {
    isFetching.value = false
  }
})

const tabs = ["Merchants", "Admins"]

type Tab = (typeof tabs)[number]
const currentTab = ref<Tab>("Merchants")

const goToTab = (tab: Tab) => {
  currentTab.value = tab
}
</script>
